import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStylesForTesting } from '../../../../Components/helper';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';

function OrderPreviewTable() {
  const { t } = useTranslation('common');

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2 bgcolor-dark d-flex">
        <strong>{t('ORDER_PREVIEW_DETAILS.ORDER_DETAILS')}</strong>
        <div className="btn btn-border ml-auto py-0 px-1">
          <div className="input-button-container bg-white">
            <CustomDatePicker
              dateFormat="dd/MM/yyyy"
              name="selectedActualApproveByDate"
              popperPlace="top-end"
              placeholder={t('ORDER_PREVIEW_DETAILS.HANDOVER_DATE')}
              disable
            />
          </div>
        </div>
        <div className="btn btn-border  py-0 px-1">
          <div className="input-button-container bg-white">
            <CustomDatePicker
              dateFormat="dd/MMM/yyyy"
              name="selectedActualApproveByDate"
              popperPlace="top-end"
              placeholder={t('ORDER_PREVIEW_DETAILS.SHIPMENT_DATE')}
              disable
            />
          </div>
        </div>
      </Card.Header>

      <Card.Body>
        <div className="table-responsive mb-2">
          <table className="table custom-table layout-fixed mb-0">
            <thead>
              <tr>
                <th className="w-150px">{t('ORDER_PREVIEW_DETAILS.REFERENCES')}</th>
                <th className="w-150px">{t('ORDER_PREVIEW_DETAILS.DESCRIPTIONS')}</th>
                <th className="w-150px">{t('ORDER_PREVIEW_DETAILS.COLOR')}</th>
                <th className="w-250px">{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
                <th className="w-250px">{t('ORDER_PREVIEW_DETAILS.QUANTITY')}</th>
                <th className="w-250px">{t('ORDER_PREVIEW_DETAILS.PRICE')}</th>
                <th className="w-130px">{t('ORDER_PREVIEW_DETAILS.PER')}</th>
                <th className="w-150px">{t('ORDER_PREVIEW_DETAILS.TOTAL')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input type="text" name="reference" className="form-control text-bordered" disabled />
                </td>
                <td>
                  <input type="text" name="description" className="form-control text-bordered" disabled />
                </td>
                <td>
                  <input type="text" name="colour" className="form-control text-bordered" disabled />
                </td>
                <td>
                  <div className="d-flex align-items-end">
                    <input type="text" name="size" className="form-control text-bordered" disabled />
                    <div className="w-80px ml-1">
                      <Select className="text-dark" styles={customStylesForTesting} placeholder="UoM" menuPosition="fixed" name="size" isDisabled />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-end">
                    <input type="text" name="quantity" className="form-control text-bordered" disabled />
                    <div className="w-80px ml-1">
                      <Select className="text-dark" styles={customStylesForTesting} placeholder="UoM" menuPosition="fixed" name="quantity" isDisabled />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-end">
                    <input type="text" name="price" className="form-control text-bordered" disabled />
                    <div className="w-80px ml-1">
                      <Select className="text-dark" styles={customStylesForTesting} placeholder="UoM" menuPosition="fixed" name="price" isDisabled />
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" name="per" className="form-control text-bordered" disabled />
                </td>
                <td>
                  <input type="text" name="total" className="form-control text-bordered" disabled />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
}
export default OrderPreviewTable;
